// Images for the PRZYRODA GOTOWA landing (WebP in Impultienda Recursos, store 3fc1d09d-cb0e-4a63-b51d-5710fef39bb8).
const BASE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/3fc1d09d-cb0e-4a63-b51d-5710fef39bb8/';

// Standard box mockup: 6 tomów, transparent, 2048 px (used by Hero, Offer and InsidePages).
export const PRODUCT_IMAGE = `${BASE}1792638685159_przyroda-gotowa-mockup-estandar-caja-6-tomow-transparente-af98efca.webp`;

// 5 real pages of Tom 1 (Gamma Estudio, corrected version, 1512x1890). Labels: data/przyroda.ts (pageLabels), same order.
// s01 okładka · s11 lekcja 1 z INSTRUKCJĄ · s12 karta pracy na 3 poziomach · s29 doświadczenie z BEZPIECZEŃSTWEM · s37 klucz odpowiedzi
export const PAGE_SAMPLES: string[] = [
  `${BASE}1792638957782_pg-tom1-s01-5d654108.webp`,
  `${BASE}1792640325278_pg-tom1-v2-s11-89cd1799.webp`,
  `${BASE}1792640329745_pg-tom1-v2-s12-6642102e.webp`,
  `${BASE}1792640333729_pg-tom1-v2-s29-135de3c1.webp`,
  `${BASE}1792640337695_pg-tom1-v2-s37-5072e9db.webp`
];
